/**
 * @file GenerateContentLanding.tsx
 * @description Wrapper component for GenerateContent component.
 */

import React from "react";
import GenerateContent from "./GenerateContent";

const GenerateContentLanding: React.FC = () => (
  <>
    <div className="mb-20">
      <h2 className="text-center !text-6xl !font-medium">
        Migliora il tuo risultato
      </h2>
      <p className="text-center text-primary-content text-2xl font-light">
        Dicci qualcosa in più, e prova FpS Content Generator
      </p>
    </div>
    <GenerateContent showHeader={false} />
  </>
);

export default GenerateContentLanding;
